// https://prod-henk-search.search.windows.net/indexes/henk-abp-articles-test/docs?api-version=2020-06-30-Preview&search=*
export default class AzureSearchApiSettings {
  constructor(settings) {
    this.searchServiceName = null;
    this.searchServiceAdminApiKey = '5B19F67CFEA1A870B28F3BCD4CD5C9B6';
    this.searchServiceQueryApiKey = '3ADAC7C0EEF51BB4DF3D19C93C704A02';
    this.indexName = 'aquaco-abp-articles-test';
    this.apiVersion = '2017-11-11';
    this.url = 'https://prod-aquaco-search.search.windows.net';
    this.corsSettings = [];
    if (settings) {
      if (settings.searchServiceName)
        { this.searchServiceName = settings.searchServiceName; };
      if (settings.searchServiceAdminApiKey)
        { this.searchServiceAdminApiKey = settings.searchServiceAdminApiKey; };
      if (settings.searchServiceQueryApiKey)
        { this.searchServiceQueryApiKey = settings.searchServiceQueryApiKey; };
      if (settings.indexName) this.indexName = settings.indexName;
      if (settings.apiVersion) this.apiVersion = settings.apiVersion;
      if (settings.url) this.url = settings.url;
      if (settings.corsSettings) this.corsSettings = settings.corsSettings;
    }
  }
}
